<template>
  <div class="redPackList clearfix">
    <template v-if="envelopeList.length">
      <div class="redPack" :class="{'fade': item.status !== 1}" v-for="item in envelopeList" :key="item.id">
        <div class="red-pack-price">{{item.redenvelopesPrice | decimal}}</div>
        <div class="red-pack-name">{{item.store_name ? item.store_name : '无'}}</div>
        <div class="red-pack-desc">适用范围：满{{item.subtotal}}元使用</div>
        <div class="red-pack-time">{{item.activityEndtime}}前有效</div>
      </div>
    </template>
    <template v-else>
      <empty>暂无可用红包</empty>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
import {getMyred} from "@/api/xunyou";
import Empty from '../../../components/empty';

export default {
  name: 'redPackList',
  props: {
    status: Number
  },
  components: {
    Empty
  },
  data() {
    return {
      loading: false,
      envelopeList: []
    }
  },
  mounted () {
    this.searchRedEnvelope();
  },
  methods: {
    // 红包查询
    searchRedEnvelope() {
      getMyred({muid:this.$store.getters.userId, status: this.status})
        .then((res) => {
          console.log('红包列表：', res);
          if (res.code === 0) {
            this.envelopeList = res.rows;
          } else {
            this.$message.error(res.msg);
          }
        }).catch((err) => {
          this.loading = false;
          this.$message.error("查询红包失败，请稍后再试！");
        });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.redPack{
  position: relative;
  width: 277px;
  float: left;
  margin: 0 20px 20px 0;
  text-align: center;
  color: #FFFFFF;
  background: linear-gradient(to bottom, #ff7435, #ffba6d);
  box-sizing: border-box;
  &:before{
    content: '';
    display: block;
    border-radius: 0 0 300px 300px;
    height: 10px;
    width: 30px;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &.fade{
    filter: grayscale(1);
  }
  .red-pack-price{
    font-size: 25px;
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 10px;
    &:before{
      content: '￥';
      font-size: 12px;
    }
    &:after{
      content: '';
      display: block;
      margin: 0 auto;
      width: 120px;
      height: 1px;
      background-color: #fff;
    }
  }
  .red-pack-desc{
    margin: 10px 20px 20px 20px;
    color: #888888;
    height: 80px;
    padding: 10px;
    text-align: left;
    border-radius: 3px;
    background-color: #fff;
  }
  .red-pack-time{
    border-top: 1px dashed #F5F5F5;
    padding: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/redPackList.vue